import React, { useEffect, useState } from "react";
import { productData as staticProductData } from "../../static/data";
import styles from "../../styles/style";
import ProductCard from "../route/productCard/ProductCard";
import { useSelector } from "react-redux";

const SuggestedProduct = ({ data }) => {
  const { allProducts } = useSelector((state) => state.products);
  const [productData, setProductData] = useState([]);
  useEffect(() => {
    if (data) {
      const val =
        allProducts && allProducts.length > 0 ? allProducts : staticProductData;
      const filteredProducts = val.filter((i) => i.category === data.category);
      setProductData(filteredProducts);
    }
  }, [data, allProducts]);
  return (
    <div>
      {data ? (
        <div className={`p-4 ${styles.section}`}>
          <h2
            className={`${styles.heading} text-[25px] font-[500] border-b mb-5`}
          >
            Related Product
          </h2>
          <div className="grid grid-cols-1 gap-[20px] mmd:grid-cols-2 md:gap-[25px] lg:grid-cols-4 lg:gap-[25px] xl:grid-cols-5 xl:gap-[30px]">
            {productData &&
              productData.map((i, index) => {
                <ProductCard data={i} key={i?._id || i?.id} />;
              })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SuggestedProduct;
